import React, { useState, useEffect } from 'react'
import { movieApi, categoryApi } from '../services/api'

const MoviesSection = () => {
  const [movies, setMovies] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      setLoading(true)
      const [moviesRes, categoriesRes] = await Promise.all([
        movieApi.list(),
        categoryApi.list('movie')
      ])
      
      if (moviesRes.code === 0) setMovies(moviesRes.data)
      if (categoriesRes.code === 0) setCategories(categoriesRes.data)
    } catch (err) {
      setError('加载数据失败')
    } finally {
      setLoading(false)
    }
  }

  const getMoviesByCategory = (categoryId) => {
    return movies.filter(movie => movie.category_id === categoryId)
  }

  if (loading) {
    return (
      <section className="section">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>加载中...</p>
        </div>
      </section>
    )
  }

  if (error) {
    return (
      <section className="section">
        <div className="error">{error}</div>
      </section>
    )
  }

  return (
    <section className="section">
      <div className="section-header">
        <span className="section-title">AI 主题电影精选</span>
        <span className="section-count">// 必看经典</span>
      </div>
      
      {categories.map(category => {
        const categoryMovies = getMoviesByCategory(category.id)
        if (categoryMovies.length === 0) return null
        
        return (
          <div key={category.id}>
            <div className="category-label">{category.name}</div>
            <div className="card-grid grid-2">
              {categoryMovies.map((movie, index) => (
                <div 
                  key={movie.id} 
                  className="movie-card card-anim"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div 
                    className="movie-thumb" 
                    style={{ background: movie.thumb_gradient || 'linear-gradient(135deg,#1a1a2e,#16213e)' }}
                  >
                    {movie.thumb_icon && movie.thumb_icon.startsWith('data:image') ? (
                      <img src={movie.thumb_icon} alt={movie.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    ) : movie.thumb_icon && movie.thumb_icon.startsWith('http') ? (
                      <img src={movie.thumb_icon} alt={movie.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    ) : (
                      movie.thumb_icon || '🎬'
                    )}
                  </div>
                  <div className="movie-info">
                    <div className="movie-title">{movie.title}</div>
                    <div className="movie-year">
                      {movie.year && `${movie.year} · `}
                      {movie.director && `${movie.director}导演`}
                    </div>
                    <div className="movie-desc">{movie.description}</div>
                    {movie.tags && movie.tags.length > 0 && (
                      <div className="movie-tags">
                        {movie.tags.map((tag, i) => (
                          <span key={i} className="movie-tag">{tag}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </section>
  )
}

export default MoviesSection
